import React, { useState, useEffect } from 'react';
import {
  Widget,
  MasterDetailForm,
  Row,
  InlineEditColumnProps,
  Table,
  Button,
} from '@digital/ui';
import { Collapse, Icon } from 'antd';
import { CrfRequisitadoSemOrdemCompra } from '@app/api/crf/crfprojeto';

interface FormResumoCapexProps {
  requisitoCompra: CrfRequisitadoSemOrdemCompra[];
  projetoId: string;
  style: any;
}

const { Panel } = Collapse;

const FormTableRequisitadoCompraCrfProjeto = (props: FormResumoCapexProps) => {
  const { requisitoCompra, projetoId, style } = props;

  const [valorTotal, setValorTotal] = useState<string>();

  useEffect(() => {
    const getData = () => {
      if (requisitoCompra.length > 0) {
        var requisitado = requisitoCompra[requisitoCompra.length - 1];
        if (requisitado) {
          setValorTotal(requisitado.distribuidoTotalFormatado);
        } else {
          setValorTotal('');
        }
      } else {
        setValorTotal('');
      }
    };

    getData();
  }, [requisitoCompra]);

  const customColumns = () => {
    return [
      {
        title: 'N',
        dataIndex: 'index',
        width: '1%',
      },
      {
        title: 'RC',
        dataIndex: 'requisicaoCompraNumero',
        width: '2%',
      },
      {
        title: 'RC Seq',
        dataIndex: 'requisicaoCompraSeq',
        width: '1%',
      },
      {
        title: 'Principal',
        dataIndex: 'principalFormatado',
        width: '1%',
      },
      {
        title: 'Narrativa',
        dataIndex: 'narrativa',
        width: '35%',
      },
      {
        title: 'Valor total',
        dataIndex: 'requisicaoCompraValorTotalFormatado',
        width: '5%',
      },
      {
        title: 'No Projeto',
        dataIndex: 'valorDistribuidoFormatado',
        key: 'valorTotalCurrency',
        children: [
          {
            title: `${valorTotal || ''}`,
            dataIndex: 'valorDistribuidoFormatado',
            width: '1%',
          },
        ],
      },
      {
        title: 'Valor à distribuir',
        dataIndex: 'valorParaDistribuidoFormatado',
        width: '5%',
      },
    ] as InlineEditColumnProps<CrfRequisitadoSemOrdemCompra>[];
  };

  return (
    <>
      <Collapse
        bordered={false}
        defaultActiveKey={['2']}
        expandIcon={() => <Icon type="arrows-right_4" />}
        style={style}>
        <Panel key="2" header="ITENS DE REQUISIÇÃO DE COMPRA SEM ORDEM DE COMPRA" style={{ border: 0 }}>
          <MasterDetailForm>
            <Widget
              actions={[
                projetoId && (
                  <Button
                    title="Distribuir Requisitado(Sem OC)"
                    type="primary"
                    icon="commons-search"
                    onClick={() => {
                      window.location.href = `/Cr/moduloRequisitado/requisicaoCompra`;
                    }}
                  />
                ),
              ]}>
              <Row>
                <Table rowKey="index" columns={customColumns()} dataSource={requisitoCompra} />
              </Row>
            </Widget>
          </MasterDetailForm>
        </Panel>
      </Collapse>
    </>
  );
};

export default FormTableRequisitadoCompraCrfProjeto;
